
<template>
    <div>
        <TransitionFade>
            <div class="z-[39] fixed left-0 top-0 w-full h-full backdrop-blur-xl" v-show="isCategoryOpen"></div>
        </TransitionFade>

        <div class="fixed bottom-4 md:bottom-8 left-8 right-8 md:left-0 md:right-0 mx-auto z-[39] max-w-xs md:max-w-sm bg-black rounded-lg shadow">
            <TransitionFade>
                <OrganismPopup v-if="isPopupVisible" class="absolute bottom-[140px]" @close="closePopup"/>
            </TransitionFade>
            <div
                class="relative h-[60px] transition-[height] duration-500 p-4 border-gray-800 border-solid border-b-2 flex flex-col items-center justify-center gap-4"
                :class="isCategoryOpen ? '!h-[80svh]' : ''"
            >
                <div :class="isCategoryOpen ? '!opacity-100 !visible !static' : ''" class="absolute opacity-0 invisible transition-[opacity] delay-300">
                    <AtomIconButton @click="closeCategory" icon="close" class="absolute top-4 right-4 z-20" />
                    <div class="flex flex-col gap-6 text-center">
                        <button
                            v-for="subcategory in subcategories"
                            :key="`subcategory-${subcategory.id}`"
                            @click="handleSubcategoryClick(subcategory)"
                            type="button"
                            class="text-white font-bold text-lg text-center transition-all opacity-40"
                            :class="selectedSubCategory && selectedSubCategory.id === subcategory.id ? '!text-pink !opacity-100' : ''"
                        >
                            {{ subcategory.name }}
                        </button>
                    </div>
                </div>
                <div :class="!isCategoryOpen ? '!opacity-100 !visible !static' : ''" class="absolute opacity-0 invisible transition-[opacity] delay-300 font-normal text-white text-center w-full h-full">
                    <button class="h-full w-full flex items-center justify-center" v-if="!selectedSubCategory" @click="openCategory">
                        {{ $t('exploreAllThemes') }}
                    </button>

                    <span v-else class="flex items-center gap-3 justify-center">
                        <button @click="openCategory">
                            <span class="text-pink">{{ selectedSubCategory.name }}</span>
                        </button>

                        <button @click="setSelectedSubCategory(null)" class="flex">
                            <span class="material-symbols-outlined text-white">close</span>
                        </button>
                    </span>
                </div>
            </div>
            <div class="flex items-center p-4 text-center" >
                <span class="flex-1" :class="!isGrid ? 'text-white' : 'text-gray-600'">{{$t('timeline')}}</span>
                <div class="flex items-center flex-1 justify-center">
                    <RouterLink :to="{ name: switchRoute }">
                        <AtomToggle :checked="isGrid" />
                    </RouterLink>
                </div>
                <span class="flex-1" :class="!isGrid ? 'text-gray-600' : 'text-white'">{{$t('grid')}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import OrganismPopup from "./OrganismPopup.vue";
import AtomToggle from "../../global/atoms/AtomToggle.vue";
import AtomIconButton from "../../global/atoms/AtomIconButton.vue";
import TransitionFade from "../../../transitions/TransitionFade.vue";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
export default {
  name: "OrganismBottomToggle",
    components: {TransitionFade, AtomIconButton, AtomToggle, OrganismPopup},
    data: () => ({
        isPopupVisible: false,
        isCategoryOpen: false,
    }),
    mounted() {
      if (this.shouldDisplayPopup) {
          this.isPopupVisible = true;
      }
      if (!this.subcategories) {
          this.getCategories();
      }
    },
    methods: {
        ...mapActions('search', ['getCategories']),
        ...mapMutations('event', ['setSelectedSubCategory']),
        closePopup(){
            this.isPopupVisible = false;
            localStorage.setItem("shouldDisplayAnarchiveFilterPopup", 'no');
        },
        openCategory(){
            this.isCategoryOpen = !this.isCategoryOpen;
            this.isPopupVisible = false;
        },
        closeCategory(){
            this.isCategoryOpen = false;
        },
        handleSubcategoryClick(subCategory) {
            this.setSelectedSubCategory(subCategory);
            this.closeCategory();
        }
    },
    computed: {
        ...mapState('event', {
            selectedSubCategory: 'selectedSubCategory',
        }),
        ...mapGetters('search', {
            subcategories: 'getHeadingSubcategories',
        }),
        shouldDisplayPopup() {
            return localStorage.getItem("shouldDisplayAnarchiveFilterPopup") !== 'no';
        },
        currentRouteName() {
            return this.$route.name;
        },
        isGrid() {
            return this.currentRouteName === 'anarchive.grid';
        },
        switchRoute() {
            return this.isGrid ? 'anarchive.chrono' : 'anarchive.grid';
        }
    }
}
</script>
